import api from '@/api';
import { QuotationSuppliersRequest } from './QuotationsSuppliers.types';
import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/quotations`;

export async function vinculateSupplierInQuotation(
  obj: QuotationSuppliersRequest,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${obj.quotationId}/suppliers`,
    obj,
    null,
  )) as unknown;

  return result;
}
